











import { Component, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import {
  MentoringDescription,
  MentoringProcess,
} from '@/pages/profile/modules';
import { IMentoringInquiry } from './types';

@Component({
  components: {
    Button,
    MentoringDescription,
    MentoringProcess,
  },
})
export default class MentoringInquiry extends Vue implements IMentoringInquiry {
  goToRequests(): void {
    this.$router.push({ name: 'profile-newrequests' });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/inquiry/MentoringInquiry.vue